export const BASE_URL = 'localhost:3000';
export const PAGE_TABLE_SIZE = 30;
export const GRID_SIZE = 3;
export const FEEDBACK_TABLE_SIZE = 3;
export const MAX_FILE_SIZE = 5242880; //Bytes
export const ALLOWED_IMAGE_EXTENTIONS = ['.jpg', '.png', '.gif'];
export const NUMBER_OF_IMAGES = 3;
export const NUMBER_OF_RANK_QUESTION_IMAGES = 1;
export const POST_MEDIA_ROOT_FOLDER = 'post-media/';
export const API_KEY = 'AIzaSyAt4u8m6jjQUnxyl3kMW7K7S6yah3lhxrM';
export const MIN_DONATE = 1;
export const PAYPAL_APP_ID =
    'AUTHGVYo_WsZ1INC1rwXmOURU7OpAVPEgUogRE5fRmH0r4eaiqZNa1Vj1CIFTyIJYbCljVFK41X79rNx';
export const PAYPAL_ENV = 'production';
export const EDIT_POST_MINUTES = 2;
export const DEFAULT_IMAGE = {
    downloadMediaUrl:
        'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fdefault.png?alt=media&token=39ec78b2-a0ec-4b14-bc73-c974b8aee612',
};
